<div class="text-center thank-you">
  <div class="wrapper">
    <img class="logo" src="assets/images/logo.png" />
    <div>
      <p>Your epione.net profile has been successfully updated.</p>
    <p>
      To access your profile and manage your healthcare, download the epione.net
      Patients App.
    </p>
    </div>
    <div class="download-logos">
      <a href="https://play.google.com/store/apps/details?id=net.epione.patient&pcampaignid=web_share"><img src="assets/images/google-play.png" /></a>
      <a href="https://apps.apple.com/za/app/epione-net-patients/id1487920012"><img src="assets/images/app-store.png" /></a>
    </div>
  </div>
</div>
